module.exports = __webpack_public_path__ + "static/media/hombre.6eae33ef.png";